import React, {useState, useEffect} from "react";
import {Link} from "react-router-dom";
import { useParams} from "react-router-dom";
import axios from 'axios';

import Navbar from "../../components/navbar";

import Footer from "../../components/footer";

import PropertyImageGallery from "../../components/propertyimagegallery";
import inquireButton from "../../assect/images/buttons/Inquire.png";

// const apiPath = 'https://localhost:7044/DimoraProperties';
// const apiPath = 'http://54.90.37.158/dimoraapi/dimoraproperties';
//const apiPath = 'https://dimoralivingwebapi.azurewebsites.net/dimoraproperties';
const apiPath = 'https://dimoraliving.com/dimoraproperties';

export default function PropertyDetail() {

    const [property, setProperty] = useState({});
    const [propertyId, setPropertyId] = useState(0);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [open, setIsOpen] = useState(false);

    const mime = 'image/jpg';
    
    const handleImageClick = (index) => {
        setCurrentImageIndex(index);
        setIsOpen(true);
    };

    const { id } = useParams();
    
    const fetchData = async (apiGetPath) => {
        
        try {
            // grab data from api and place into state
            const response = await axios.get(apiGetPath);
            const data = response.data;
            
            setProperty(prevState => ({
                ...prevState, ...data[0]
            }));
            
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        setPropertyId(id);
    }, []);
    
    useEffect(() =>{
        let apiGetPath = `${apiPath}/${propertyId}`;
        
        fetchData(apiGetPath);
    }, [propertyId])
    
    // useEffect(() => { console.log(property); }, [property]);

    const formatDate = (date) => {
        return new Date(date).toLocaleDateString('en-US');
    };
    
    return (
    <div style={{backgroundColor: "#f0eadd"}}>
        <Navbar navClass="defaultscroll sticky" menuClass = "navigation-menu nav-right"/>
        <div className="container mt-100">
            {property.imageDefs === undefined ?
                <span className="loader"></span> :
                
                <div className="row g-5 pt-50 pb-100 ps-100">
                    <div className="col-lg-8 col-md-6 col-12 mb-60" style={{width: "660px"}}>
                            <div className="container-fluid mt-2">
                                <div className="row g-2 mb-2">
                                    <div className="col-md-12">
                                        <PropertyImageGallery property={property}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className="col-lg-4 col-md-4 col-12" style={{paddingTop: "25px"}} >
                            <div className="row g-2">
                                <div className="col-md-6">
                                    <ul className="property-stats">
                                        <li><p style={{fontSize: "15px", lineHeight: "1.5rem", fontWeight: "bold"}}>{`${property.address.toUpperCase()}, UNIT ${property.unit}`}</p></li>
                                        <li><p style={{fontSize: "15px", lineHeight: "1.5rem", fontWeight: "bold"}}>{`${property.city.toUpperCase()}, ${property.state.toUpperCase()}`}</p></li>
                                        <li><p style={{fontSize: "15px", lineHeight: "1.5rem", fontWeight: "bold"}}><span style={{fontWeight: "bold"}}>{`$${property.price}`}/MONTH</span></p></li>
                                        <li><p style={{fontSize: "15px", lineHeight: "1.5rem", fontWeight: "bold"}}><span style={{fontWeight: "bold"}}>{`Available: ${property.available === true ? 'Yes' : 'No'}`}</span></p></li>
                                    </ul>
                                </div>
                                
                                <div className="col-md-6">
                                    <ul className="property-stats">
                                        <li><p style={{fontSize: "15px", lineHeight: "1.5rem", fontWeight: "bold"}}><span className="me-3" style={{fontWeight: "bold"}}>{`BEDS: ${property.beds}  /  BATHS: ${property.baths}`}</span></p></li>
                                        <li><p style={{fontSize: "15px", lineHeight: "1.5rem", fontWeight: "bold"}}><span className="me-3" style={{fontWeight: "bold"}}>{`SQFT: ${property.sqft}`}</span></p></li>
                                        <li><p style={{fontSize: "15px", lineHeight: "1.5rem", fontWeight: "bold"}}><span className="me-3" style={{fontWeight: "bold"}}>{property.rentalType === 'F' ? "FURNISHED" : "UNFURNISHED"}</span></p></li>
                                        {property.available ? <li><p style={{fontSize: "15px", lineHeight: "1.5rem", fontWeight: "bold"}}><span className="me-3" style={{fontWeight: "bold"}}>{`Date: ${formatDate(property.availableDt)}`}</span></p></li> : null}
                                    </ul>
                                </div>
                            </div>
                            <div className="row g-2 mt-14">
                                <p style={{fontSize: "16px"}}>{property.description}</p>
                                <Link to="/contactus" target="_blank">
                                    <img src={inquireButton} alt="Inquire" width="100" height="41"/>
                                </Link>
                            </div>
        
                        </div>
                </div>
            }
        </div>
        <Footer/>        
    </div>)
}